import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { useDonHangMuaTrongNuocSearchContext } from '../../context';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  formMode: FormMode;
}

export const OtherTab = ({ formMode }: OtherTabProps) => {
  const { transactionOptions } = useDonHangMuaTrongNuocSearchContext();
  const { watch, setValue } = useFormContext();
  const maGD = watch('ma_gd');

  useEffect(() => {
    if (maGD || !transactionOptions?.length) return;

    setValue('ma_gd', transactionOptions[0]?.value, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: true
    });
  }, [maGD, setValue, transactionOptions]);

  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-28 min-w-28'>Giao dịch</Label>
          <div className='w-[250px]'>
            <FormFieldV2 name='ma_gd' type='select' disabled={formMode === 'view'} options={transactionOptions} />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-28 min-w-28'>Lý do hủy</Label>
          <div className='flex-1'>
            <FormFieldV2 name='ly_do_huy' type='text' disabled={formMode === 'view'} />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-28 min-w-28'>Ghi chú</Label>
          <div className='flex-1'>
            <FormFieldV2 name='ghi_chu' type='text' disabled={formMode === 'view'} />
          </div>
        </div>
      </div>
    </div>
  );
};
